// Generated by ReScript, PLEASE EDIT WITH CARE


let cardNoInputTestId = "cardNoInput";

let expiryInputTestId = "expiryInput";

let cardCVVInputTestId = "cvvInput";

let cardHolderNameInputTestId = "BillingName";

let fullNameInputTestId = "FullName";

let emailInputTestId = "email";

let addressLine1InputTestId = "line1";

let cityInputTestId = "city";

let countryDropDownTestId = "Country";

let stateDropDownTestId = "State";

let postalCodeInputTestId = "postal";

let fieldTestIdMapping = {
  "billing.address.city": cityInputTestId,
  "billing.address.country": countryDropDownTestId,
  "billing.address.first_name": cardHolderNameInputTestId,
  "billing.address.last_name": cardHolderNameInputTestId,
  "billing.address.line1": addressLine1InputTestId,
  "billing.address.state": stateDropDownTestId,
  "billing.address.zip": postalCodeInputTestId,
  email: emailInputTestId,
  "payment_method_data.card.card_cvc": cardCVVInputTestId,
  "payment_method_data.card.card_exp_month": expiryInputTestId,
  "payment_method_data.card.card_exp_year": expiryInputTestId,
  "payment_method_data.card.card_holder_name": fullNameInputTestId,
  "payment_method_data.card.card_number": cardNoInputTestId
};

let paymentMethodListTestId = "paymentList";

let paymentMethodDropDownTestId = "paymentMethodsSelect";

let addNewCardIcon = "addNewCard";

let datePickerPlaceHolderText = "Enter Date of Birth";

export {
  paymentMethodListTestId,
  paymentMethodDropDownTestId,
  cardNoInputTestId,
  expiryInputTestId,
  cardCVVInputTestId,
  cardHolderNameInputTestId,
  fullNameInputTestId,
  emailInputTestId,
  addressLine1InputTestId,
  cityInputTestId,
  countryDropDownTestId,
  stateDropDownTestId,
  postalCodeInputTestId,
  addNewCardIcon,
  datePickerPlaceHolderText,
  fieldTestIdMapping,
}
/* No side effect */
